<div class="wrap">
    <h2>Historique des containers clicote</h2>
</div>